<template>
  <div />
</template>
<script>

  import pigeon from "../../utilities/js/pigeon/pigeon";
  import dataLayerMixin from "../../utilities/vueMixins/dataLayerMixin/dataLayerMixin";
  import globalStateComputedMixin from "../../utilities/vueMixins/globalStateComputedMixin/globalStateComputedMixin";

  export default {
    mixins: [
      dataLayerMixin,
      globalStateComputedMixin
    ],
    mounted() {
      this.trackEvent({
        event: 'eec.checkout',
        ecommerce: {
          checkout: {
            actionField: {
              step: 5
            },
            products: this.cartContent
          }
        }
      });

      document.querySelectorAll('.js-submit-button')
        .forEach(button => {
          button.onclick = function (event) {
            event.preventDefault();
            if (document.querySelector("[name=paymentType]:checked")) {
              document.querySelectorAll(".js-payment-error")
                .forEach(function (error) {
                  error.classList.remove("display-error");
                });

              if (document.querySelector("[name=paymentType]:checked").value === 'CREDIT_CARD'
                && pigeon.hasEvent('checkCreditCard')) {
                pigeon.publish('checkCreditCard');
              } else if (document.querySelector("[name=paymentType]:checked").value === 'INVOICE'
                && pigeon.hasEvent('checkGuestCheckoutPassword')) {
                pigeon.publish('checkGuestCheckoutPassword');
              } else {
                document.paymentbaseform.submit();
              }
            } else {
              document.querySelectorAll(".js-payment-error")
                .forEach(function (error) {
                  error.classList.add("display-error");
                });
            }
          }
        });
    }
  };

</script>
